/**
 * Sort Column Overrides
 *
 * Maps display column codes to the actual Azure Search field used for sorting.
 * Use this when a column's display value doesn't sort correctly in Azure Search
 * (e.g., string fields that contain numeric values).
 *
 * Key:   the columnCode shown in the UI (what the user clicks to sort)
 * Value: the Azure Search field to use in the $orderby clause instead
 *
 * Example: FboWorkOrderNumber  is stored as a string but users expect numeric sorting.
 *          FboAssignmentId is an integer that produces the correct numeric order.
 */
export const SORT_COLUMN_OVERRIDES: Record<string, string> = {
  FboWorkOrderNumber : 'FboAssignmentId',
}
